import type { ReactNode } from 'react';
import type { User } from '../types';
import SearchInput from './SearchInput';
import { UNASSIGNED_TECHNICIAN_VALUE } from '../utils/orderFilters';

interface OrdersFilterBarProps {
  technicians: User[];
  technicianId: string;
  onTechnicianChange: (id: string) => void;
  search: string;
  onSearchChange: (value: string) => void;
  children?: ReactNode;
}

// Одинаковый набор фильтров (поиск + сантехник) на всех трёх видах нарядов
// (Список/Канбан/Календарь) — каждый вид может добавить свой контрол через children
export default function OrdersFilterBar({
  technicians,
  technicianId,
  onTechnicianChange,
  search,
  onSearchChange,
  children,
}: OrdersFilterBarProps) {
  return (
    <div className="orders-filter-bar">
      <SearchInput value={search} onChange={onSearchChange} placeholder="Номер, адрес, клиент, телефон..." />
      <select value={technicianId} onChange={(e) => onTechnicianChange(e.target.value)}>
        <option value="">Все сантехники</option>
        <option value={UNASSIGNED_TECHNICIAN_VALUE}>Не назначен</option>
        {technicians.map((t) => (
          <option key={t.id} value={t.id}>
            {t.fullName}
          </option>
        ))}
      </select>
      {children}
    </div>
  );
}
